export default "__VITE_ASSET__d930fcdf__"